import { Button, Paper, Popover } from "@mui/material";
import CustomSelect from "./CustomSelect";
import { Option } from "../constants/common";
import { ReactNode, useState } from "react";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";

interface ButtonWithSelectProps {
  options: Option[];
  value?: string | null;
  multiple?: boolean;
  onChange?: (value: string | null) => void;
  rightIcon?: ReactNode;
  label?: string;
  w?: string | number;
  onSearch?: (e: React.SyntheticEvent, v: string) => void;
}

const ButtonWithSelect = ({
  onSearch,
  rightIcon,
  options,
  onChange,
  value,
  multiple,
  label,
  w = "180px",
}: ButtonWithSelectProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        startIcon={rightIcon ?? <AddCircleOutlineOutlinedIcon />}
        endIcon={<ExpandMoreOutlinedIcon />}
        variant="outlined"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {label ?? "Add new"}
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Paper sx={{ width: w }}>
          <CustomSelect
            placeholder="Search Here"
            value={value}
            options={options}
            onSearch={onSearch}
            onChange={(v) => {
              onChange?.(v);
              if (!multiple) setAnchorEl(null);
            }}
          />
        </Paper>
      </Popover>
    </>
  );
};

export default ButtonWithSelect;
